var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      class: { loading: _vm.loading },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        }
      }
    },
    [
      _c("x-errors-messages", { attrs: { errors: _vm.errors } }),
      _vm._v(" "),
      _vm._t("default", null, { loading: _vm.loading })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }